import { createFileRoute } from '@tanstack/react-router'
import { IncidentSettings } from '@/features/organizations/settings/incident-settings'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/incident-settings'
)({
  component: IncidentSettings,
})
